import { render, staticRenderFns } from "./D2C_LayoutDrawerCustomiseCoverFormSpecifiedItems.vue?vue&type=template&id=736b67c7&scoped=true&"
import script from "./D2C_LayoutDrawerCustomiseCoverFormSpecifiedItems.vue?vue&type=script&lang=js&"
export * from "./D2C_LayoutDrawerCustomiseCoverFormSpecifiedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b67c7",
  null
  
)

export default component.exports